// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__27QFJ","logo":"Header_logo__3EvUy"};